import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenent_select_draw_winner: { message: "idle" },
};

export const tenent_select_draw_winner_Slice = createSlice({
 name: "tenent_select_draw_winner",
 initialState,
 reducers: {
  success_tenent_select_draw_winner: (state, action) => {
   state.tenent_select_draw_winner = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenent_select_draw_winner: (state, action) => {
   state.tenent_select_draw_winner = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenent_select_draw_winner: (state) => {
   state.tenent_select_draw_winner = { status: app_consts.IDLE };
  },
  loading_tenent_select_draw_winner: (state) => {
   state.tenent_select_draw_winner = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenent_select_draw_winner, fail_tenent_select_draw_winner, reset_tenent_select_draw_winner, loading_tenent_select_draw_winner } = tenent_select_draw_winner_Slice.actions;

export default tenent_select_draw_winner_Slice.reducer;